import React from 'react';
import { useQueryLoader } from '@/hooks/use-query-loader';

export const QueryLoaderProvider = ({ children }: { children: React.ReactNode }) => {
  // Use the hook with default options
  useQueryLoader({
    delay: 150, // Show loader after 150ms to avoid flickering
    showOnFetch: true,
    showOnMutate: true,
  });

  return <>{children}</>;
};